import React from "react";
import Meta from "../Meta";
import Loader from "../loader";
import WebEditorRender from "../../../components/WebEditor";
import AiHtmlIframe from "../../../components/AiHtmlIframe";
import { applyLang } from "../../../i18n";
import { resolveImage } from "../utils";

export default function CustomPage({ context, loading }) {
    const { data } = context;
    const page = applyLang(data?.[0] || {}, context.lang);

    let lang = context.lang?.value || null;
    const languages = context.org.languages || [];
    if (languages.length > 0 && !lang) lang = context.org.language;

    const metaTitle = page.metaTitle || page.title;
    const metaDescription = page.metaDescription || page.description;
    const metaImage = page.metaImage ? resolveImage(page.metaImage) : null;

    if (loading) {
        return (
            <>
                <Meta context={context} seo={page} title={metaTitle} description={metaDescription} image={metaImage} />
                <Loader />
            </>
        );
    }

    return (
        <>
            <Meta context={context} seo={page} title={metaTitle} description={metaDescription} image={metaImage} />
            <div style={context.render !== "embed" ? { marginTop: 20, minHeight: "60vh" } : undefined}>
                {page.editorType === "AI" ? (
                    <AiHtmlIframe html={page.html} i18n={page.i18n} mainLang={page.mainLang} lang={lang} linkBehavior="top" />
                ) : (
                    <WebEditorRender page={page} lang={lang} />
                )}
            </div>
        </>
    );
}
